import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useAuth } from '@/features/auth/contexts/auth.context';
import { useInterviewContext } from '@/features/common/contexts/interview.context';
import KioskOtpScreen from '@/features/kiosk/pages/KioskOtpScreen';

import { useRegisterContext } from '../../contexts/register-context.ref';

export default function OtpPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();
  const { onReset } = useInterviewContext();

  const {
    kioskOtpState: otpState,
    handleOtpVerificationSuccess,
    handleOtpResend,
    handleEmailFallback,
    handleSmsFallback,
    handleClearSmsError,
    handleOtpBack,
  } = useRegisterContext();

  useEffect(() => {
    if (!otpState) {
      if (isAuthLoading) {
        return;
      }
      if (isAuthenticated) {
        navigate('/payment', { replace: true });
        return;
      }
      navigate('/language', { replace: true });
    }
  }, [otpState, isAuthenticated, isAuthLoading, navigate]);

  if (!otpState) {
    return null;
  }

  return (
    <KioskOtpScreen
      otpContext={otpState}
      onVerified={handleOtpVerificationSuccess}
      onResend={handleOtpResend}
      onEmailFallback={handleEmailFallback}
      onSmsFallback={handleSmsFallback}
      onClearSmsError={handleClearSmsError}
      onBack={handleOtpBack}
      onCancel={onReset}
    />
  );
}
